export default "__VITE_ASSET__5b0e28e7__"